<template>
  <div>
    <div class="espacio"></div>

    <!-- Encabezado -->
    <div class="mb-3">
      <div class="row">
        <div class="col-3">
        </div>
        <div class="col-11">
          <div v-if="mensajeDetalle"
               class="form-control is-invalid d-inline-block"
               style="width:auto">
            {{ mensajeDetalle }}
          </div>
        </div>
      </div>
    </div>

<Modal v-model:modelValue="showModalHelp" title="Ayuda — Detalle de Atención">
  <AyudaAtencionDet />
</Modal>

    <!--  DataTable  -->
    <DataTable
      :data="atenciondets"
      :columns="columnas"
      idField="idAtencionDet"
      :acciones="true"
      :mostrarBotonTodos="false"
      :mostrarBotonNuevo="true"
      :mostrarBotonExcel="false"
      :mostrarInfo="false"
      :mostrarEditar="estadoPermitido"
      :mostrarVer="false"
      :mostrarEliminar="estadoPermitido"
      mensajeVacio="No hay detalles registrados."
      @refresh="cargarDatos()"
      @create="abrirModalCrear"
      @edit="({ idAtencionDet }) => abrirModalEditar(idAtencionDet)"
      @delete="({ idAtencionDet }) => deleteAtencionDet(idAtencionDet)"
    >
      <!-- Celda: Precio total calculado -->
      <template #cell-precioTotal="{ row }">
        <span class="d-block text-end">
          {{ (row.cantidad * row.precioUnitario).toFixed(2) }}
        </span>
      </template>

      <!-- Celdas numéricas alineadas a la derecha -->
      <template #cell-cantidad="{ row }">
        <span class="d-block text-end">{{ row.cantidad }}</span>
      </template>

      <template #cell-precioUnitario="{ row }">
        <span class="d-block text-end">{{ row.precioUnitario }}</span>
      </template>

      <!-- Footer con total -->
      <template #acciones-extra>
        <div class="col-auto ms-auto fw-bold small text-end pe-2">
          Total: {{ totalPrecioTotal.toFixed(2) }}
        </div>
      </template>

      <!-- Botón de ayuda -->
      <template #boton-ayuda>
        <button
          class="btn-help"
          type="button"
          title="Abrir ayuda del detalle de atención"
          @click="showModalHelp = true"
          aria-label="Abrir ayuda del detalle de atención"
        >
          <span class="material-symbols-outlined">help</span>
        </button>
      </template>
    </DataTable>

    <!--  Modal crear / editar  -->
    <div class="modal fade" id="ventanaModal" tabindex="-1"
         aria-labelledby="modalAtencionDetLabel" aria-hidden="true"
         v-if="modalWindow">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white" id="modalAtencionDetLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white"
                    data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">

            <!-- LOV de elementos -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-2">
                  <label class="form-label">Elemento</label>
                </div>
                <div class="col-10">
                  <div class="input-group">
                    <input type="text" class="form-control"
                           v-model="searchTextElem"
                           @input="filterElementos()"
                           @keyup.enter="toggleDropdown()"
                           placeholder="Buscar elemento...">
                    <button class="btn btn-outline-secondary dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            ref="dropdownButton">
                      <i class="fa fa-search"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end shadow"
                        style="max-height:250px;overflow-y:auto;width:100%"
                        ref="dropdownMenu">
                      <li v-for="elem in filteredElementos" :key="elem.idElemEmpr">
                        <a class="dropdown-item text-truncate"
                           href="#"
                           @click.prevent="selectElemento(elem)"
                           :title="elem.elementoNombre">
                          {{ elem.elementoCodigo }} - {{ elem.elementoNombre }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- Precio y cantidad -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-2">
                  <label class="form-label">Precio Unitario</label>
                </div>
                <div class="col-4">
                  <input type="number" class="form-control"
                         v-model.number="datoAtencionDet.precioUnitario"
                         min="0" step="0.01" required
                         @input="datoAtencionDet.precioUnitario = Math.max(0, datoAtencionDet.precioUnitario || 0)">
                </div>
                <div class="col-2">
                  <label class="form-label">Cantidad</label>
                </div>
                <div class="col-4">
                  <input type="number" class="form-control"
                         v-model.number="datoAtencionDet.cantidad"
                         min="0" step="1" required
                         @input="datoAtencionDet.cantidad = Math.max(0, datoAtencionDet.cantidad || 0)">
                </div>
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button v-if="btnCrear" type="button"
                    class="btn btn-success"
                    @click.prevent="guardarAtencionDet()">
              <span class="material-symbols-outlined align-middle"
                    style="font-size:32px">save</span>
              Guardar
            </button>
            <button v-if="btnEditar" type="button"
                    class="btn btn-success"
                    @click.prevent="guardarEditAtencionDet()">
              <span class="material-symbols-outlined align-middle"
                    style="font-size:32px">update</span>
              Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import AyudaAtencionDet  from '@/views/ayuda/AyudaAtencionDet.vue'
import DataTable         from '@/components/DataTable.vue'
import { validarForm }   from '@/modules/validacionesForms.js'
import api               from '@/services/api'
import { openModal, closeModal } from '@/modules/modalHelper.js'
import swal              from 'sweetalert'

export default {
  name: 'AtencionDet',
  components: { AyudaAtencionDet, DataTable },

  props: {
    p_idAtencion:     { type: Number, required: true },
    p_estadoAtencion: { type: String, required: true },
  },

  data() {
    return {
      atenciondets:      [],
      datoAtencionDet:   {},
      titulo:            '',
      btnCrear:          false,
      btnEditar:         false,
      modalWindow:       true,
      elemEmprs:         [],
      filteredElementos: [],
      searchTextElem:    '',
      mensajeDetalle:    '',
      showModalHelp:     false,

      columnas: [
        { field: 'elementoCodigo',  label: 'Código' },
        { field: 'elementoNombre',  label: 'Descripción' },
        { field: 'cantidad',        label: 'Cantidad' },
        { field: 'precioUnitario',  label: 'Precio Unitario' },
        { field: 'precioTotal',     label: 'Precio Total' },
      ],
    }
  },

  computed: {
    estadoPermitido() {
      return ['PENDIENTE', 'PROCESO'].includes(this.p_estadoAtencion)
    },

    // Total calculado sobre todos los registros (no solo la página)
    totalPrecioTotal() {
      return this.atenciondets.reduce(
        (acc, d) => acc + (d.cantidad * d.precioUnitario), 0
      )
    },
  },

  mounted() {
    this.cargarDatos()
    this.fetchElemEmprs()
  },

  methods: {
    //  Carga de datos
    cargarDatos() {
      api.get(`/vwatenciondets/idatencion/${this.p_idAtencion}`)
        .then(response => { this.atenciondets = response.data.reverse() })
        .catch(error   => console.error('Error cargando detalles:', error))
    },

    fetchElemEmprs() {
      const idEmpresa = window.sessionStorage.getItem('idEmpresa')
      api.get(`/vwelememprs/idempresa/${idEmpresa}`)
        .then(response => {
          this.elemEmprs         = response.data
          this.filteredElementos = response.data
        })
        .catch(error => console.error('Error fetching elementos:', error))
    },

    //  LOV de elementos
    filterElementos() {
      const q = (this.searchTextElem || '').toLowerCase()
      this.filteredElementos = q
        ? this.elemEmprs.filter(e => e.elementoNombre.toLowerCase().includes(q))
        : this.elemEmprs
    },

    selectElemento(elem) {
      this.datoAtencionDet.idElemEmpr = elem.idElemEmpr
      this.searchTextElem = `${elem.elementoCodigo} - ${elem.elementoNombre}`
      this.actualizarPrecioUnitario()
    },

    toggleDropdown() {
      this.$refs.dropdownButton.click()
    },

    actualizarPrecioUnitario() {
      const found = this.elemEmprs.find(e => e.idElemEmpr === this.datoAtencionDet.idElemEmpr)
      if (found) {
        this.datoAtencionDet.precioUnitario = found.valor
        this.datoAtencionDet.cantidad       = 1
        this.datoAtencionDet.idImpuesto     = found.idImpuesto
      }
    },

    //  Validación
    validarForm() {
      return validarForm(
        this.datoAtencionDet,
        ['idElemEmpr', 'cantidad', 'precioUnitario'],
        ['idElemEmpr', 'cantidad', 'precioUnitario']
      )
    },

    //  CRUD
    async guardarAtencionDet() {
      if (this.validarForm() !== 1) return
      try {
        this.datoAtencionDet.idAtencion = this.p_idAtencion
        await api.post('/atenciondets', this.datoAtencionDet)
        closeModal('ventanaModal')
        swal('Correcto!', 'Detalle creado exitosamente!', 'success')
        this.cargarDatos()
      } catch {
        swal('Error!', 'Inténtelo de nuevo!', 'error')
      }
    },

    async guardarEditAtencionDet() {
      if (this.validarForm() !== 1) return
      try {
        await api.post('/atenciondets', this.datoAtencionDet)
        closeModal('ventanaModal')
        swal('Correcto!', 'Detalle actualizado exitosamente!', 'success')
        this.cargarDatos()
      } catch (error) {
        swal('Error!', 'Inténtelo de nuevo!', 'error')
        if (error.response?.data?.errors) {
          Object.values(error.response.data.errors).forEach(e => swal(String(e)))
        }
      }
    },

    async deleteAtencionDet(idAtencionDet) {
      try {
        await api.delete(`/atenciondets/${idAtencionDet}`)
        this.cargarDatos()
      } catch {
        swal('Error!', 'No se pudo eliminar.', 'error')
      }
    },

    //  Apertura de modal
    abrirModalCrear() {
      this.modalWindow     = true
      this.datoAtencionDet = {}
      this.searchTextElem  = ''
      this.titulo          = 'Detalle (Servicios y Recursos de Atención)'
      this.btnCrear        = true
      this.btnEditar       = false
      openModal('ventanaModal')
    },

    abrirModalEditar(idAtencionDet) {
      if (!this.estadoPermitido) {
        this.mensajeDetalle = `La acción no está permitida porque el estado es ${this.p_estadoAtencion}.`
        return
      }
      this.modalWindow = true
      if (idAtencionDet) {
        api.get(`/vwatenciondets/${idAtencionDet}`).then(resp => {
          this.datoAtencionDet = resp.data
          this.searchTextElem  = `${resp.data.elementoCodigo} - ${resp.data.elementoNombre}`
        })
      }
      this.titulo    = 'Detalle (Servicios y Recursos de Atención)'
      this.btnCrear  = false
      this.btnEditar = true
      openModal('ventanaModal')
    },
  },
}
</script>

<style src="@/assets/css/listaFiltrada02.css" scoped></style>
<style src="@/assets/css/tabla_estilizada.css" scoped></style>
<style src="@/assets/css/listaRegistros.css" scoped></style>
<style scoped>
.espacio { margin-top: 0.25em; }
</style>